module.exports = __webpack_public_path__ + "img/a-star-is-born.70e1c55a.jpg";